import { FC, ReactNode } from 'react'
import { StyleButton, StyleButtonWrapper } from './style'
import theme from '@utils/theme'
import Svg from '@components/svg'
interface ButtonProps {
  type?: 'button' | 'submit' | 'reset'
  title: string
  width?: number
  height?: number
  bg?: keyof typeof theme.colors
  tc?: keyof typeof theme.colors
  radius?: number
  styleButton?: string
  leftComponent?: ReactNode
  rightComponent?: ReactNode
  onClick?: (val: any) => void
  icon?: any
  justify?: string
}
const Button: FC<ButtonProps> = ({
  type = 'button',
  title,
  leftComponent,
  rightComponent,
  icon,
  justify,
  ...restProps
}) => {
  return (
    <StyleButtonWrapper justify={justify}>
      <StyleButton type={type} {...restProps}>
        {!!icon && icon}
        {leftComponent && leftComponent}
        {title}
        {rightComponent && rightComponent}
      </StyleButton>
    </StyleButtonWrapper>
  )
}

export default Button
